<template>
  <v-app>
    <v-content>
      <v-container v-if="loading" fluid>Carregando...</v-container>
      <v-container v-else :key="status" fluid>
        <Navigation-Bar />
        <FilterBar :status="status" />
        <!-- <v-btn
          v-show="accessList.includes(email.toLowerCase())"
          depressed
          color="primary"
          style="margin-bottom: 20px; margin-left: 40px"
          @click="select()"
        >
          Redirecionados
        </v-btn>
        <v-btn
          v-show="accessList.includes(email.toLowerCase())"
          depressed
          color="primary"
          style="margin-bottom: 20px; margin-left: 40px"
          @click="selectDashboard()"
        >
          Monitoramento
        </v-btn>

        <v-btn
          v-show="accessList.includes(email.toLowerCase())"
          depressed
          color="primary"
          style="margin-bottom: 20px; margin-left: 40px"
          @click="selectRandom()"
        >
          Randômico
        </v-btn> -->

        <!-- <ControlPanel /> -->
        <Dashboard />
        <!-- <Random /> -->
        <Table />
        <Details />
        <!-- <Redirect /> -->
        <!-- <Download v-show="accessList.includes(email.toLowerCase())" /> -->
        <!-- <Notifications /> -->
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

import Table from "@/components/table";
import Details from "@/components/details";
// import Redirect from "@/components/redirect";
// import Download from "@/components/download";
// import Notifications from "@/components/notifications";
import FilterBar from "@/components/filter-bar";
import NavigationBar from "@/components/navigation-bar";
// import ControlPanel from "@/components/control-panel";
import Dashboard from "@/components/dashboard";
// import Random from "@/components/random";

export default {
  name: "App",

  components: {
    FilterBar,
    // Redirect,
    Details,
    // ControlPanel,
    NavigationBar,
    Table,
    // Notifications,
    // Download,
    Dashboard,
    // Random,
  },

  data: () => ({
    email: "",
    accessList: [
      // "raphael.anjos@qwst.co",
      // "suely.rosales@qwst.co",
      // "wellington.galeno@qwst.co",
      "",
    ],
    loading: false,
  }),

  computed: {
    ...mapState(["error"]),

    status() {
      switch (this.$route.path) {
        case "/total":
          return -1;
        case "/novos":
          return 0;
        case "/andamento":
          return 1;
        case "/concluidos":
          return 2;
        case "/atrasados":
          return 3;
        default:
          return 0;
      }
    },
  },

  methods: {
    ...mapMutations([
      "setParams",
      "setDefaultParams",
      "setDashboardParams",
      "setRandomParams",
      // "setControlPanelActive",
      "setDashboardActive",
      "setRandomActive",
    ]),
    ...mapActions(["getRedirectTable", "getDashboardTable", "getRandomTable"]),

    // select() {
    //   this.getRedirectTable();
    //   this.setControlPanelActive({ controlPanelActive: true });
    // },

    selectDashboard() {
      this.getDashboardTable();
      this.setDashboardActive({ dashboardActive: true });
    },

    selectRandom() {
      this.getRandomTable();
      this.setRandomActive({ randomActive: true });
    },
  },

  watch: {
    status() {
      this.setDefaultParams({
        email_gerente: this.$route.query.pad_email || "",
      });

      this.setDashboardParams({
        email_gerente: this.$route.query.pad_email || "",
      });

      this.setRandomParams({
        email_gerente: this.$route.query.pad_email || "",
      });
    },
  },

  beforeMount() {
    // this.$route.query.pad_email = "";
    this.setParams({
      email_gerente: this.$route.query.pad_email || "",
    });
    this.setDashboardParams({
      email_gerente: this.$route.query.pad_email || "",
    });
    this.setRandomParams({
      email_gerente: this.$route.query.pad_email || "",
    });
  },

  mounted() {
    this.email = this.$route.query.pad_email;
    // this.email = "";
    // let pad_email = localStorage.getItem("pad_email");
    // console.log("local pad_email", pad_email);
    // console.log("this.$route.query.pad_email", this.$route.query.pad_email);
    // console.log("this.email", this.email);
    // this.email = "wellington.galeno@qwst.co";
    // this.email = "suely.rosales@qwst.co";
    this.$vuetify.theme.dark = false;
  },
};
</script>
